import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { UserCheck } from "lucide-react";
import { useIdentity } from "@/lib/identity";
import { toast } from "sonner";

export default function IdentifyDialog({ open, onOpenChange }) {
  const { identify } = useIdentity();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const emp = await identify(email.trim());
      toast.success(`Bine ai venit, ${emp.name}!`);
      setEmail("");
      onOpenChange(false);
    } catch (err) {
      const msg = err?.response?.data?.detail || "Email negăsit în director";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="identify-dialog" className="max-w-md bg-white dark:bg-zinc-900">
        <div className="flex items-center gap-3 mb-2">
          <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900">
            <UserCheck className="h-5 w-5" />
          </div>
          <div>
            <DialogTitle className="text-lg">Sunt eu</DialogTitle>
            <DialogDescription className="text-xs text-zinc-500 dark:text-zinc-400">
              Identifică-te ca să poți edita propriul profil și competențe.
            </DialogDescription>
          </div>
        </div>

        <form onSubmit={submit} className="mt-4 space-y-3">
          <label className="block">
            <span className="text-xs uppercase tracking-[0.2em] font-medium text-zinc-500 dark:text-zinc-400">Email de muncă</span>
            <input
              data-testid="identify-email-input"
              type="email"
              autoFocus
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nume.prenume@ezipper.ro"
              className="mt-1.5 w-full h-11 px-3 rounded-lg border border-border bg-white dark:bg-zinc-950 text-zinc-900 dark:text-zinc-100 placeholder:text-zinc-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 dark:focus-visible:ring-zinc-100 transition-shadow duration-150"
            />
          </label>
          <button
            data-testid="identify-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full h-11 rounded-lg bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900 font-medium hover:opacity-90 transition-opacity disabled:opacity-50"
          >
            {loading ? "Se verifică..." : "Continuă"}
          </button>
          <p className="text-[11px] text-zinc-500 dark:text-zinc-400 text-center">
            Nu se solicită parolă — verificare ușoară pentru editare profil. Datele rămân stocate doar în browserul tău.
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
